module.exports = __webpack_public_path__ + "static/media/62.4a2d42b8.jpg";